/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TunneledMcpServer,
  TunneledMcpServer$inboundSchema,
} from "./tunneledmcpserver.js";

/**
 * Rotated tunneled MCP server plus the one-time replacement tunnel key
 */
export type RotateTunneledMcpServerKeyResult = {
  /**
   * A customer-hosted MCP server connected through a tunnel
   */
  server: TunneledMcpServer;
  /**
   * Plaintext tunnel key. Only returned after rotation.
   */
  tunnelKey: string;
};

/** @internal */
export const RotateTunneledMcpServerKeyResult$inboundSchema: z.ZodMiniType<
  RotateTunneledMcpServerKeyResult,
  unknown
> = z.pipe(
  z.object({
    server: TunneledMcpServer$inboundSchema,
    tunnel_key: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "tunnel_key": "tunnelKey",
    });
  }),
);

export function rotateTunneledMcpServerKeyResultFromJSON(
  jsonString: string,
): SafeParseResult<RotateTunneledMcpServerKeyResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RotateTunneledMcpServerKeyResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RotateTunneledMcpServerKeyResult' from JSON`,
  );
}
